export default {
  retrieveAdminNotificationTemplateList (state, payload) {
    state.adminNotificationTemplateList = [].concat(payload.adminNotificationTemplateList)
  },
  getAdminNotificationTemplateInfo (state, payload) {
    state.adminNotificationTemplateInfo = payload.adminNotificationTemplateInfo
  },
  deleteAdminNotificationTemplate (state, payload) {
    state.adminNotificationTemplateList.splice(payload.adminNotificationTemplateInfo.index, 1);
  },
  saveState (state, payload) {
    state.currentPage = payload.page ? payload.page : null
  }
}
